import React, {useEffect} from 'react';
import {
    ShiftCardWrapper,
    ShiftTime,
    ShiftPrice,
    ShiftInfo,
    PharmacyName,
    PharmacyLoc,
    InstantShift,
    GreenCircle,
    SquareCircle,
    StartEndTime,
    DashedBorder,
    ExtraShiftCard,
    ShiftCardsContainer,
    ActionShiftCard, ShiftSubInfo
} from "./shift-card.styles";
import {Link} from "react-router-dom";
import moment from "moment-jalaali";
import fa from "moment/locale/fa";

moment.locale("fa", fa);
moment.loadPersian({dialect: 'persian-modern'});

const ShiftCard = ({
                       shiftsModalHandler,
                       item: {shift_times, total_duration, total_earnings, pharmacy, is_instant, shift_start, id}
                   }) => {

    useEffect(() => {

    }, []);


    return (
        <ShiftCardsContainer className='position-relative'>
            {

                shift_times.length > 1 && Array.apply(null, Array(shift_times.length - 1)).map((_, index) => (
                    <ExtraShiftCard style={{
                        left: `${(shift_times.length - 1 - index) * 4}px`,
                        top: `${(shift_times.length - 1 - index) * 6}px`
                    }} key={index}/>
                ))
            }
            <ShiftCardWrapper>
                <div>
                    <ShiftInfo>
                        <div className='d-flex justify-content-center align-items-center'>
                            <ShiftTime>{`شیفت ${parseInt(total_duration)} ساعته `}</ShiftTime>
                            {
                                !!is_instant && <InstantShift><span>فوری</span></InstantShift>
                            }
                        </div>

                        <ShiftPrice className='mb-2'><span>{parseFloat(parseInt(total_earnings) / 1000000).toFixed(1)}</span> میلیون تومان
                            /</ShiftPrice>
                    </ShiftInfo>
                    <div className='d-flex flex-column'>
                        <ShiftSubInfo className='mt-4 d-flex justify-content-center order-2 order-lg-1'>
                            <div className='text-end text-lg-center'>
                                <PharmacyName><i className='icon-hospital align-middle ms-2'/>{pharmacy.name}</PharmacyName>
                                <PharmacyLoc><i className='icon-location align-middle ms-2'/>{pharmacy.address}</PharmacyLoc>
                            </div>
                       </ShiftSubInfo>
                        <div className='mt-0 mt-c-lg-2 d-flex flex-column align-items-center order-1 order-lg-2'>
                            <div className='d-flex flex-column align-items-start'>
                                {
                                    shift_times.length > 1 ?
                                        <>
                                            <div className='d-flex align-items-end'>
                                                <GreenCircle/>
                                                <StartEndTime>{`${moment(shift_start, 'YYYY-MM-DD HH:mm:ss').format(window.screen.width > 968 ? 'از dddd jYYYY/jMM/jDD ساعت HH:mm:ss' : 'از dddd jMM/jDD ساعت HH:mm')}`}</StartEndTime>
                                            </div>
                                            <p className='fs-c-3 danger-color fw-normal align-self-center mt-3 mb-0'>شامل {shift_times.length} شیفت
                                                مجزا</p>
                                        </>
                                        :
                                        <>
                                            <div className='d-flex align-items-end'>
                                                <GreenCircle/>
                                                <StartEndTime>{`${moment(shift_times[0].from, 'YYYY-MM-DD HH:mm:ss').format(window.screen.width > 968 ? 'از dddd jYYYY/jMM/jDD ساعت HH:mm:ss' : 'از dddd jMM/jDD ساعت HH:mm')}`}</StartEndTime>
                                            </div>
                                            <DashedBorder/>
                                            <div className='d-flex align-items-start'>
                                                <SquareCircle/>
                                                <StartEndTime>{`${moment(shift_times[0].to, 'YYYY-MM-DD HH:mm:ss').format(window.screen.width > 968 ? 'تا dddd jYYYY/jMM/jDD ساعت HH:mm:ss' : 'تا dddd jMM/jDD ساعت HH:mm')}`}</StartEndTime>
                                            </div>
                                        </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <ActionShiftCard className='mt-3 mt-c-lg-2_5 text-center d-flex flex-grow-1 align-items-end justify-content-center'>
                    {
                        shift_times.length > 1 ?
                            <button className='c-btn c-btn-warning'
                                    onClick={shiftsModalHandler}>مشاهده
                                شیفت‌ها</button>
                            :
                            <Link to={`/request-single/${id}`} className='c-btn c-btn-warning'>ارسال درخواست</Link>
                    }
                </ActionShiftCard>
            </ShiftCardWrapper>
        </ShiftCardsContainer>
    )
};

export default ShiftCard;
